import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Icon from '../../../core/Icon';
import ColorPickerPopover from './Color/PickerPopover';
import { withStyles } from '@material-ui/core/styles';
import getDataProps from '../../../utils/propsUtil';
var DEFAULT_COLOR = 'inherit';
/**
 * @extends {React.PureComponent<import('../types').FormInputColorButtonProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */

export var ColorButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ColorButton, _React$PureComponent);

  function ColorButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ColorButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ColorButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      showPicker: false
    };

    _this.onColorPick = function (color) {
      return _this.props.onChange(color);
    };

    _this.onTogglePicker = function () {
      if (_this.props.onOpened) _this.props.onOpened();

      _this.setState(function (prevState) {
        return {
          showPicker: !prevState.showPicker
        };
      });
    };

    _this.onHidePicker = function () {
      if (_this.props.onClosed) _this.props.onClosed();

      _this.setState({
        showPicker: false
      });
    };

    return _this;
  }

  _createClass(ColorButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          classes = _this$props.classes,
          type = _this$props.type;
      var showPicker = this.state.showPicker;
      var colorValue = value || DEFAULT_COLOR;
      var label = type === 'foreground' ? 'Text color' : 'Background color';
      return React.createElement(ColorPickerPopover, {
        onChange: this.onColorPick,
        value: colorValue,
        open: showPicker,
        onClose: this.onHidePicker
      }, React.createElement(Icon, Object.assign({
        onClick: this.onTogglePicker,
        buttonProps: {
          className: classes.buttonIcon
        },
        color: "action",
        label: label,
        underlineColor: colorValue,
        type: type,
        buttonSize: "medium"
      }, getDataProps(this.props))));
    }
  }]);

  return ColorButton;
}(React.PureComponent);
var styles = {
  buttonIcon: {
    width: 32,
    height: 40
  }
};
/**@type {Partial<import('../types').FormInputColorButtonProps & import('utils/types').TestableComponentProps>} */

ColorButton.defaultProps = {
  value: DEFAULT_COLOR,
  type: 'foreground',
  'data-testid': 'color-button'
};
export default withStyles(styles, {
  name: 'ECColorButton'
})(ColorButton);